




























































































































import Vue from 'vue';
import key from '@/libs/filters/key';
import { Component, Prop } from 'vue-property-decorator';
import { TReturnForm } from '@/types/views/school';
import { getOrgList } from '@/api/school';
import { TOrgList } from '@/types/views/school'
@Component({})
export default class Search extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;

  private key: any = key;
  private form: TReturnForm = {
    packageNo: '',
    dimUser: '',
    dealStatus: '',
    dimCourseName: '',
    minCreateTime: '',
    maxCreateTime: '',
    minDealTime: '',
    maxDealTime: '',
    orgId: ''
  };

  // add by_ALi
  private orgList = []

  private created() {
      this.getOrgList({orgId: ''});
  }

  /**
   * 获取校区列表
   * @param {TOrgList} params
   */
  private async getOrgList(params: TOrgList) {
      try {
          let res: any = await getOrgList(params);
          console.log(res)
          this.orgList = res;
      } catch (e) {
          this.$message.error(e);
      }
  }


  private search() {
    const f = this.form,
      opts = {
        ...f
      };
    this.handleOptions(opts);
    this.getData();
  }
  private reset() {
    this.form = {
      packageNo: '',
      dimUser: '',
      dealStatus: '',
      dimCourseName: '',
      minCreateTime: '',
      maxCreateTime: '',
      minDealTime: '',
      maxDealTime: '',
      orgId: ''
    };
    this.search();
  }
}
